import { NgModule } from '@angular/core';
import { LibErrorIconComponent } from './lib-error-icon.component';

@NgModule({
  declarations: [LibErrorIconComponent],
  exports: [LibErrorIconComponent],
})
export class LibErrorIconModule {}
